import { BaseEvents } from '@/shared/utils';
import { StudySessions } from './types/study-sessions';

export const StudySessionEventKeys = {
  studySession: {
    options: 'studySession/options/get',
    profile: 'studySession/profile/get',
    update: 'studySession/profile/update',
  },
} as const;

export interface StudySessionEvents extends BaseEvents {
  'studySession/options/get': void;
  'studySession/profile/get': { email: string };
  'studySession/profile/update': StudySessions[0];
}
